function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2048 2048",
    style: {
      enableBackground: "new 0 0 2048 2048"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_41_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A24BDB"
    },
    points: "1768,1381.15 1707.41,1407.01 1681.55,1467.6 1655.8,1407.01 1595.21,1381.15  1655.8,1355.4 1681.55,1294.81 1707.41,1355.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D20763"
    },
    d: "M450.19,320.1c28.11,0,51.02,22.91,51.02,51.02c0,27.99-22.91,50.9-51.02,50.9 c-27.99,0-50.9-22.91-50.9-50.9C399.29,343.01,422.2,320.1,450.19,320.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD93B"
    },
    d: "M991.23,392.73c318.52,0,576.7,357.62,576.7,676.03c0,318.53-258.18,576.71-576.7,576.71 c-318.41,0-576.59-258.18-576.59-576.71C414.64,750.35,672.82,392.73,991.23,392.73z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M991.23,1669.504c-81.067,0-159.724-15.886-233.786-47.217 c-71.524-30.258-135.755-73.568-190.909-128.729c-55.155-55.164-98.461-119.406-128.715-190.945 c-31.329-74.08-47.214-152.76-47.214-233.853c0-80.262,16.193-166.141,46.829-248.351 c30.064-80.677,74.118-158.193,127.398-224.168c56.051-69.405,120.064-124.463,190.262-163.644 c75.967-42.402,155.415-63.901,236.135-63.901c80.746,0,160.213,21.499,236.197,63.9 c70.212,39.18,134.236,94.238,190.295,163.644c53.287,65.973,97.346,143.489,127.412,224.168 c30.637,82.209,46.83,168.087,46.83,248.352c0,81.095-15.886,159.774-47.216,233.853 c-30.257,71.541-73.566,135.784-128.729,190.946c-55.161,55.162-119.403,98.473-190.942,128.729 C1151,1653.618,1072.322,1669.504,991.23,1669.504z M991.23,416.764c-141.654,0-279.804,74.465-389,209.678 C499.816,753.254,438.674,918.607,438.674,1068.76c0,304.746,247.875,552.676,552.556,552.676 c304.741,0,552.666-247.93,552.666-552.676c0-150.159-61.146-315.511-163.568-442.317 C1271.116,491.229,1132.932,416.764,991.23,416.764z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M1343.322,750.057c-7.76,0-15.374-3.75-20.008-10.686 c-38.516-57.655-84.911-106.72-134.17-141.891c-10.803-7.713-13.308-22.723-5.595-33.526 c7.713-10.802,22.724-13.309,33.526-5.594c54.71,39.062,103.901,90.98,146.209,154.309c7.373,11.038,4.403,25.962-6.635,33.336 C1352.55,748.745,1347.91,750.057,1343.322,750.057z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M352.28,572.784c-13.274,0-24.034-10.76-24.034-24.034v-24.92 c0-13.274,10.76-24.034,24.034-24.034s24.034,10.76,24.034,24.034v24.92C376.314,562.024,365.554,572.784,352.28,572.784z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M424.44,620.144h-24.8c-13.274,0-24.034-10.76-24.034-24.034s10.76-24.034,24.034-24.034h24.8 c13.274,0,24.034,10.76,24.034,24.034S437.714,620.144,424.44,620.144z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M352.28,692.304c-13.274,0-24.034-10.76-24.034-24.034v-24.8 c0-13.274,10.76-24.034,24.034-24.034s24.034,10.76,24.034,24.034v24.8C376.314,681.544,365.554,692.304,352.28,692.304z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M304.92,620.144H280c-13.274,0-24.034-10.76-24.034-24.034s10.76-24.034,24.034-24.034h24.92 c13.274,0,24.034,10.76,24.034,24.034S318.194,620.144,304.92,620.144z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M450.19,446.054c-41.319,0-74.934-33.615-74.934-74.934c0-41.385,33.615-75.054,74.934-75.054 c41.385,0,75.054,33.669,75.054,75.054C525.244,412.439,491.575,446.054,450.19,446.054z M450.19,344.134 c-14.814,0-26.866,12.106-26.866,26.986c0,14.814,12.052,26.866,26.866,26.866c14.88,0,26.986-12.052,26.986-26.866 C477.176,356.24,465.07,344.134,450.19,344.134z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M1681.55,1491.634c-0.006,0-0.012,0-0.019,0c-9.634-0.007-18.333-5.767-22.101-14.634 l-21.966-51.684l-51.689-22.061c-8.86-3.782-14.607-12.489-14.6-22.124c0.007-9.634,5.767-18.333,14.634-22.101l51.664-21.957 l21.956-51.665c3.769-8.867,12.468-14.626,22.102-14.634c0.006,0,0.013,0,0.019,0c9.628,0,18.325,5.744,22.105,14.6 l22.062,51.69l51.684,21.966c8.867,3.768,14.627,12.467,14.634,22.101c0.008,9.635-5.739,18.342-14.6,22.124l-51.71,22.069 l-22.069,51.709C1699.876,1485.889,1691.177,1491.634,1681.55,1491.634z M1656.548,1381.197l8.687,3.707 c5.711,2.438,10.257,6.99,12.685,12.705l3.678,8.653l3.708-8.688c2.433-5.699,6.972-10.238,12.671-12.671l8.687-3.707 l-8.652-3.678c-5.715-2.428-10.268-6.974-12.705-12.685l-3.708-8.688l-3.677,8.653c-2.434,5.727-6.993,10.285-12.72,12.719 L1656.548,1381.197z M1655.8,1355.4h0.01H1655.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M1481.95,1632.294c-13.273,0-24.034-10.761-24.034-24.034v-24.8 c0-13.273,10.761-24.034,24.034-24.034s24.034,10.761,24.034,24.034v24.8C1505.984,1621.533,1495.224,1632.294,1481.95,1632.294 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M1554.11,1679.774h-24.801c-13.273,0-24.034-10.761-24.034-24.034s10.761-24.034,24.034-24.034 h24.801c13.273,0,24.034,10.761,24.034,24.034S1567.384,1679.774,1554.11,1679.774z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M1481.95,1751.935c-13.273,0-24.034-10.761-24.034-24.034V1703.1 c0-13.273,10.761-24.034,24.034-24.034s24.034,10.761,24.034,24.034v24.801 C1505.984,1741.174,1495.224,1751.935,1481.95,1751.935z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M1434.47,1679.774h-24.8c-13.273,0-24.034-10.761-24.034-24.034s10.761-24.034,24.034-24.034 h24.8c13.273,0,24.034,10.761,24.034,24.034S1447.743,1679.774,1434.47,1679.774z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M1172.267,1361.49c-10.54,0-20.21-6.986-23.152-17.64 c-29.562-106.998-127.465-181.727-238.084-181.727h-23.15c-110.614,0-208.513,74.729-238.073,181.727 c-3.535,12.795-16.774,20.301-29.567,16.766c-12.794-3.534-20.301-16.771-16.766-29.566 c35.297-127.763,152.25-216.994,284.406-216.994h23.15c132.163,0,249.119,89.231,284.417,216.994 c3.535,12.795-3.972,26.032-16.766,29.566C1176.539,1361.208,1174.385,1361.49,1172.267,1361.49z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M1170.131,859.124c-36.524,0-70.077-6.274-100.27-18.792 c-47.481-19.687-71.33-48.845-79.379-60.467c-7.558-10.912-4.838-25.885,6.074-33.442s25.885-4.839,33.442,6.074 c5.602,8.086,58.715,78.274,197.401,53.106c13.057-2.369,25.568,6.297,27.939,19.356c2.37,13.061-6.297,25.569-19.357,27.939 C1213.103,857.05,1191.125,859.124,1170.131,859.124z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M628.788,859.123c-20.997,0-42.967-2.073-65.85-6.225c-13.061-2.37-21.727-14.879-19.356-27.939 s14.877-21.728,27.939-19.356c53.444,9.699,100.251,6.444,139.123-9.674c36.691-15.213,53.885-37.093,58.281-43.437 c7.56-10.91,22.533-13.627,33.444-6.066c10.91,7.56,13.626,22.533,6.066,33.444c-8.053,11.622-31.91,40.779-79.379,60.462 C698.867,852.849,665.308,859.123,628.788,859.123z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M688.29,1003.154c-24.836,0-48.252-9.645-65.934-27.159c-9.431-9.341-9.503-24.559-0.162-33.989 c9.341-9.431,24.558-9.503,33.989-0.162c8.621,8.539,20.023,13.242,32.106,13.242c12.205,0,23.726-4.808,32.442-13.538 c8.743-8.75,13.554-20.317,13.554-32.578c0-13.274,10.76-24.034,24.034-24.034s24.034,10.76,24.034,24.034 c0,25.093-9.806,48.727-27.612,66.547C736.951,993.337,713.349,1003.154,688.29,1003.154z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121"
    },
    d: "M1110.63,1003.154c-25.051,0-48.654-9.815-66.462-27.637 c-17.809-17.837-27.612-41.469-27.612-66.547c0-13.274,10.761-24.034,24.034-24.034s24.034,10.76,24.034,24.034 c0,12.254,4.813,23.824,13.555,32.579c8.72,8.727,20.247,13.537,32.451,13.537c12.084,0,23.479-4.7,32.089-13.235 c9.428-9.345,24.645-9.278,33.99,0.148c9.345,9.427,9.278,24.645-0.148,33.989 C1158.889,993.507,1135.474,1003.154,1110.63,1003.154z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.7276284963ded5a6a0792a37b4e28bd5.svg";
export { ForwardRef as ReactComponent };